import React from 'react';
import Icon from '../../../components/AppIcon';
import { Card, CardHeader, CardTitle, CardContent } from '../../../components/ui/Card';
import Button from '../../../components/ui/Button';
import Badge from '../../../components/ui/Badge';

const ExpiringLockinsWidget = ({ expiringTenants, onViewAll }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const getDaysUntilExpiry = (dateString) => {
    const today = new Date();
    const expiryDate = new Date(dateString);
    const diffTime = expiryDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const getUrgencyVariant = (days) => {
    if (days <= 7) return 'danger';
    if (days <= 14) return 'warning';
    return 'success';
  };

  return (
    <Card shadow="md" className="border border-border">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <Icon name="Clock" size={20} className="text-primary-500" />
            Expiring Lock-ins
          </CardTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={onViewAll}
            iconName="ArrowRight"
            iconPosition="right"
          >
            View All
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {expiringTenants?.slice(0, 4)?.map((tenant) => {
            const daysLeft = getDaysUntilExpiry(tenant?.lockin_end_date);
            return (
              <div
                key={tenant?.id}
                className="flex items-center justify-between p-3 rounded-lg bg-muted hover:bg-neutral-100 transition-smooth"
              >
                <div className="flex-1">
                  <h4 className="text-body font-medium text-foreground mb-1">
                    {tenant?.name}
                  </h4>
                  <div className="flex items-center gap-3 text-body-sm text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="Users" size={14} />
                      {tenant?.seats} seats
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="IndianRupee" size={14} />
                      ₹{(tenant?.revenue / 1000)?.toFixed(0)}K/mo
                    </span>
                  </div>
                </div>
                <div className="text-right">
                  <Badge variant={getUrgencyVariant(daysLeft)} size="sm" className="mb-1">
                    {daysLeft} days
                  </Badge>
                  <p className="text-caption text-muted-foreground">
                    {formatDate(tenant?.lockin_end_date)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        {expiringTenants?.length === 0 && (
          <div className="text-center py-8">
            <Icon name="CheckCircle" size={48} className="text-success-500 mx-auto mb-3" />
            <p className="text-body text-muted-foreground">
              No expiring lock-ins in the next 30 days
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ExpiringLockinsWidget;